<template>
  <div class="group-pill" data-test-id="group-pill">
    <BasePill v-bind="{ ...$props, ...$attrs }">
      <template #icon>
        <GroupIcon16 />
      </template>
      <template #delete>
        <Btn icon color="grey" size="small"><CloseIcon16 /></Btn>
      </template>
    </BasePill>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import GroupIcon16 from '@components/Icons/GroupIcon16.vue';
import BasePill from '@components/common/BasePill.vue';
import CloseIcon16 from '@components/Icons/CloseIcon16.vue';

export default defineComponent({
  name: 'GroupPill',

  props: {
    // used via v-bind
    // eslint-disable-next-line
    showFullPillName: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    GroupIcon16,
    BasePill,
    CloseIcon16,
  },
});
</script>
